import { useTranslation } from "react-i18next";
import Section from "../Atoms/Section";
import styled from "styled-components";

const SocialsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 20px;
        margin: 0 20px;
    }
`;

const Footer = (props) => {

    const {i18n} = useTranslation('common');

    return (
        <Section>
            <div className="centered" style={{color:"blue",margin:"20px auto",maxWidth:"680px"}}>
                <br/>
                <SocialsContainer>
                    <a href="https://twitter.com/leFrenchDesign" target="_blank" rel="noreferrer"><img src="/img/twitter.png" alt=""/></a>
                    <a href="https://www.instagram.com/lefrenchdesign" target="_blank" rel="noreferrer"><img src="/img/instagram.png" alt=""/></a>
                    <a href="https://fr.linkedin.com/company/lefrenchdesign" target="_blank" rel="noreferrer"><img src="/img/linkedin.png" alt=""/></a>
                </SocialsContainer>
                <br/>
                <strong>{i18n.language === "fr" ? "Depuis plus de 40 ans, le VIA insuffle l’innovation française dans les espaces de vie." : "For more than 40 years, VIA has been infusing French innovation into living spaces."}</strong><br/>
                <span>{i18n.language === "fr" ? "Son projet associatif, et la diversité de ses membres (designers, architectes d’intérieur, fabricants, éditeurs et prescripteurs), favorisent écoute, agilité, créativité et rayonnement, sous le contrôle mixte des ministères de la Culture et de l’Économie." : "Its associative project, and the diversity of its members (designers, interior architects, manufacturers, publishers and prescribers), promote listening, agility, creativity and influence, under the joint control of the Ministries of Culture and the Economy."}</span><br/>
                <span><a href='/documents/ML.pdf' target='_blank' rel="noreferrer">{i18n.language === "fr" ? "Mentions légales" : "Legal notices"}</a> - <a href='https://www.lefrenchdesign.org' target='_blank' rel="noreferrer">{i18n.language === "fr" ? "Site web" : "Website"}</a> </span>
            </div>
            <img src="/img/ruban_new.png" alt="" style={{width:"100%"}}/>
        </Section>
    )
}

export default Footer;